import PlanCategories from "@/mixins/PlanCategories.js";

const tripCategoriesAllowed = [
  PlanCategories.TRIP.ID,
  PlanCategories.CRUISE.ID,
  PlanCategories.CFAR.ID,
];

export default tripCategoriesAllowed;
